import React, { useEffect} from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = (props/*{linguagem, logado, loginToParent}*/) => { 
    const navigate = useNavigate();

    useEffect(() => {
        if(props.login){
            navigate("/mapa"); 
        }
    }, [])

    function handleSubmit(e) {
        e.preventDefault();
    
        if (!e.target.email.value) {
          alert("Preencha o Email");
        } else if (!e.target.email.value) {
          alert("Email inválido");
        } else if (!e.target.password.value) {
          alert("Preencha a senha");
        } else if (
          e.target.email.value === "login@aesop.com" &&
          e.target.password.value === "123456"
        ) {
          e.target.email.value = "";
          e.target.password.value = "";
          props.loginToParent("true", "/mapa");
        } else {
          alert("Email ou Senha inválido");
        }
      };
      

    function exibePagina() {
        return (
            <center>
            <div className="Login">
            <h3>Login</h3>
            <form className="form" onSubmit={handleSubmit}>
                <div className="input-group">
                <label htmlFor="email">Email</label>
                <input type="email" name="email" placeholder="nome@email.com.br" />
                </div>
                <div className="input-group">
                <label htmlFor="password">Senha</label>
                <input type="password" name="password" />
                </div>
                <button className="primary">ENTRAR</button>
            </form>
            </div>
            </center>
        );
    }

  
    return (exibePagina());
  
}

export default Login;
